import LocalizedLink from 'components/LocalizedLink';
import React from 'react';

import classnames from 'classnames';

const CSS = require('./NavbarListItemButton.less');

interface NavbarListItemButtonProps {
  text: string;
  to: any;
  transparent?: boolean;
}

function NavbarListItemButton({ text, to, transparent }: NavbarListItemButtonProps) {
  const navbarMenuListItemClass = classnames(CSS.navbarMenuListItem, { [CSS['navbarMenuListItem-transparent']]: transparent, [CSS['navbarListItemButton-transparent']]: transparent });
  return (
    <li className={classnames(navbarMenuListItemClass, CSS.navbarListItemButton)}>
      <LocalizedLink className={CSS.navbarMenuListItemAnchor} to={to}>
        {text}
      </LocalizedLink>
    </li>
  );
}

export default NavbarListItemButton;
